import React, { useEffect, useRef } from "react"
import { Form as FForm, Field } from "react-final-form"
import { Form } from "react-bootstrap"
import { FormAutoSubmit } from "../components"

const FieldNames = {
  ShowMatched: "show_matched",
}

const initialValues = {
  [FieldNames.ShowMatched]: false,
}

export const StudentsFiltersForm = ({ onSubmit }) => {
  const submitAbilityRef = useRef(false)
  useEffect(() => {
    submitAbilityRef.current = true
  }, [])
  return (
    <FForm initialValues={initialValues} onSubmit={onSubmit} subscription={{ values: true }}>
      {({ handleSubmit }) => (
        <FormAutoSubmit
          submitAbilityRef={submitAbilityRef}
          onSubmit={handleSubmit}
          className="d-flex align-items-center gap-2"
        >
          <Field name={FieldNames.ShowMatched} type="checkbox">
            {({ input }) => (
              <Form.Check id={FieldNames.ShowMatched} label="Show matched groups" className="v-2" custom {...input} />
            )}
          </Field>
        </FormAutoSubmit>
      )}
    </FForm>
  )
}
